((document, window, history) => {
	const pushState = history.pushState;
	let footerHeight = document.querySelector('.site-footer').clientHeight;

	// default cookie compliance script
	function cookieCompliance() {
		if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
			document
				.querySelector('.farlo-ui-biscuit-banner__button')
				.addEventListener('click', (e) => {
					e.preventDefault();

					e.target
						.closest('.farlo-ui-biscuit-banner')
						.classList.add('farlo-ui-biscuit-banner--hide');

					window._farlo.storage.set(
						'cookieCompliance',
						true,
						'cookie'
					);
				});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
			document
				.querySelector('.farlo-ui-biscuit-banner__button--close')
				.addEventListener('click', (e) => {
					e.preventDefault();

					e.target
						.closest('.farlo-ui-biscuit-banner')
						.classList.add('farlo-ui-biscuit-banner--hide');
				});
		}
	}

	// navigation
	function navigation(submenu) {
		if (
			'ontouchstart' in window ||
			navigator.maxTouchPoints > 0 ||
			navigator.msMaxTouchPoints > 0
		) {
			window._farlo.helpers
				.getSiblings(submenu)[0]
				.addEventListener('click', (e) => {
					if (
						!e.target.classList.contains(
							'site-navigation__menu-item--active'
						)
					) {
						e.preventDefault();

						e.currentTarget.classList.add(
							'site-navigation__menu-item--active'
						);
						submenu.classList.add(
							'site-navigation__sub-menu--active'
						);

						for (
							let i = 0;
							i <
							window._farlo.helpers.getSiblings(
								e.currentTarget.parentNode
							).length;
							i += 1
						) {
							if (
								window._farlo.helpers.getSiblings(
									e.currentTarget.parentNode
								)[i].children[0] &&
								window._farlo.helpers
									.getSiblings(e.currentTarget.parentNode)
									[i].children[0].classList.contains(
										'site-navigation__menu-item--active'
									)
							) {
								window._farlo.helpers
									.getSiblings(e.currentTarget.parentNode)
									[i].children[0].classList.remove(
										'site-navigation__menu-item--active'
									);
							}

							if (
								window._farlo.helpers.getSiblings(
									e.currentTarget.parentNode
								)[i].children[1] &&
								window._farlo.helpers
									.getSiblings(e.currentTarget.parentNode)
									[i].children[1].classList.contains(
										'site-navigation__sub-menu--active'
									)
							) {
								window._farlo.helpers
									.getSiblings(e.currentTarget.parentNode)
									[i].children[1].classList.remove(
										'site-navigation__sub-menu--active'
									);
							}
						}
					} else {
						return true;
					}
				});
		} else {
			if (submenu) {
				submenu.parentNode.addEventListener('mouseover', () => {
					if (
						submenu.parentNode.querySelector(
							'.site-navigation__sub-menu--active'
						)
					) {
						submenu.parentNode
							.querySelectorAll(
								'.site-navigation__sub-menu--active'
							)
							.forEach((_sel) => {
								if (_sel) {
									_sel.classList.remove(
										'site-navigation__sub-menu--active'
									);
									_sel.parentNode.classList.remove(
										'site-navigation__menu-item--active'
									);
								}
							});
					}
					submenu.classList.add('site-navigation__sub-menu--active');
					submenu.parentNode.classList.add(
						'site-navigation__menu-item--active'
					);
				});
			}

			if (submenu) {
				submenu.parentNode.addEventListener('mouseout', () => {
					submenu.classList.remove(
						'site-navigation__sub-menu--active'
					);
					submenu.parentNode.classList.remove(
						'site-navigation__menu-item--active'
					);
				});
			}
		}
	}

	// default navicon
	function navicon() {
		document
			.querySelector('.site-navigation__navicon')
			.addEventListener('click', (e) => {
				e.preventDefault();
				e.currentTarget.classList.toggle(
					'site-navigation__navicon--active'
				);
				document
					.querySelector('.site-navigation-flyout')
					.classList.toggle('site-navigation-flyout--active');
				document.body.classList.toggle('site-navigation-flyout--open');
			});

		document
			.querySelector('.site-navigation-flyout__backdrop')
			.addEventListener('click', (e) => {
				document
					.querySelector('.site-navigation__navicon')
					.classList.remove('site-navigation__navicon--active');
				e.currentTarget.parentNode.classList.toggle(
					'site-navigation-flyout--active'
				);
				document.body.classList.toggle('site-navigation-flyout--open');
			});
	}

	function entranceAnimation() {
		if (document.querySelector('.klaro')) {
			document.querySelector('.klaro').classList.add('site-hidden');
		}

		document
			.querySelector('.site-entrance__svg-group:last-of-type')
			.addEventListener('animationend', () => {
				document
					.querySelector('.site-entrance__logo')
					.classList.add('site-entrance__logo--fade-in');
				document
					.querySelector('.site-entrance')
					.classList.add('site-entrance--fade-out');
			});

		document
			.querySelector('.site-entrance__logo')
			.addEventListener('animationend', () => {
				document
					.querySelector('.site-logo')
					.classList.add('site-logo--show');

				if (document.querySelector('.klaro')) {
					document
						.querySelector('.klaro')
						.classList.remove('site-hidden');
				}
				setTimeout(() => {
					document.querySelector('.site-entrance').remove();
				}, 800);
			});

		window._farlo.storage.cookie.handle(
			'entranceSeen',
			true,
			432e3,
			'/',
			window.location.host
		);
	}

	function horizontalAccordion() {
		const items = document.querySelectorAll(
			'.site-horizontal-accordion__list-item'
		);
		let accordionRunning = false;
		let accordionInterval;

		function startAccordions() {
			if (accordionRunning) {
				return;
			}

			accordionRunning = true;

			const activeItem = document.querySelector(
				'.site-horizontal-accordion__list-item--active'
			);
			const nextItem = activeItem.nextElementSibling || items[0];
			activeItem.classList.remove(
				'site-horizontal-accordion__list-item--active'
			);
			nextItem.classList.add(
				'site-horizontal-accordion__list-item--active'
			);

			setTimeout(() => {
				accordionRunning = false;
			}, 6000);
		}

		function startInterval() {
			if (window._farlo.storage.cookie.get('entranceSeen')) {
				accordionInterval = setInterval(startAccordions, 6000);
			}
		}

		function stopInterval() {
			clearInterval(accordionInterval);
		}

		function resizeHeights() {
			const config = {
				cellAlign: 'left',
				wrapAround: true,
				draggable: true,
				pageDots: true,
				prevNextButtons: false,
				autoPlay: true,
				lazyLoad: false,
				watchCSS: true,
			};

			const carousel = new Flickity(items[0].parentNode, config);
		}

		function handleItemClick(e) {
			if (
				e.currentTarget.classList.contains(
					'site-horizontal-accordion__list-item--active'
				)
			) {
				location.href = e.currentTarget
					.querySelector('.site-horizontal-accordion__info-buttons')
					.querySelector('.button--secondary')
					? e.currentTarget
							.querySelector(
								'.site-horizontal-accordion__info-buttons'
							)
							.querySelector('.button--secondary').href
					: e.currentTarget
							.querySelector(
								'.site-horizontal-accordion__info-buttons'
							)
							.querySelector('.button--primary');
				return;
			}

			e.currentTarget.classList.add(
				'site-horizontal-accordion__list-item--active'
			);

			for (
				let i = 0;
				i < window._farlo.helpers.getSiblings(e.currentTarget).length;
				i += 1
			) {
				if (
					window._farlo.helpers
						.getSiblings(e.currentTarget)
						[i].classList.contains(
							'site-horizontal-accordion__list-item--active'
						)
				) {
					window._farlo.helpers
						.getSiblings(e.currentTarget)
						[i].classList.remove(
							'site-horizontal-accordion__list-item--active'
						);
				}
			}

			stopInterval();
		}

		function handleItemMouseOver(e) {
			if (
				e.currentTarget.classList.contains(
					'site-horizontal-accordion__list-item--active'
				)
			) {
				stopInterval();
			}
		}

		startInterval();

		items.forEach((_sel) => {
			_sel.addEventListener('click', handleItemClick);
			_sel.addEventListener('mouseover', handleItemMouseOver);
			_sel.addEventListener('mouseleave', startInterval);
		});

		window.addEventListener('resize', resizeHeights);
		window.addEventListener('load', resizeHeights);
	}

	function carousels() {
		document
			.querySelectorAll('.site-gallery__images, .revolver-carousel')
			.forEach((_sel) => {
				const reviews = _sel.classList.contains('site-reviews__list');
				const eventGallery = _sel.classList.contains(
					'site-event-hero-banner__gallery'
				);
				const featuredEvents = _sel.classList.contains(
					'site-events__upcoming-events-featured-items'
				);

				if (_sel.children.length > 1) {
					const config = {
						cellAlign: 'center',
						wrapAround: true,
						draggable: true,
						pageDots: false,
						prevNextButtons: false,
						autoPlay:
							eventGallery || reviews || featuredEvents
								? 4000
								: false,
						lazyLoad: true,
					};

					if (
						_sel.classList.contains(
							'site-photogallery__list--thumbnails'
						)
					) {
						config.asNavFor = _sel.parentNode.querySelector(
							'.site-photogallery__list--highlighted'
						);
						config.cellAlign = 'left';
						config.wrapAround = false;
						config.lazyLoad = 4;
					}

					if (
						_sel.classList.contains(
							'site-events__upcoming-events-items--slider'
						)
					) {
						config.autoPlay = true;
					}

					if (
						_sel.classList.contains(
							'site-event-hero-banner__images'
						)
					) {
						config.setGallerySize = false;
					}

					if (
						_sel.classList.contains(
							'site-events__upcoming-events-items'
						)
					) {
						config.cellAlign = 'left';
						config.autoPlay = 4000;
						config.watchCSS = true;
					}

					const carousel = new Flickity(_sel, config);
					const cellsButtonGroup = _sel.parentNode.querySelector(
						'.revolver-carousel__nav-pager'
					);

					if (cellsButtonGroup) {
						const utils = window.fizzyUIUtils;
						const cellsButtons = utils.makeArray(
							cellsButtonGroup.children
						);

						// update buttons on select
						carousel.on('select', function () {
							const previousSelectedButton =
								cellsButtonGroup.querySelector('.is-selected');
							const selectedButton =
								cellsButtonGroup.children[
									carousel.selectedIndex
								];
							previousSelectedButton.classList.remove(
								'is-selected'
							);
							selectedButton.classList.add('is-selected');
						});

						// cell select
						cellsButtonGroup.addEventListener(
							'click',
							function (event) {
								if (
									!matchesSelector(
										event.target,
										'.revolver-carousel__nav-pager-button'
									)
								) {
									return;
								}
								const index = cellsButtons.indexOf(
									event.target
								);
								carousel.select(index);
							}
						);
					}

					// previous
					const previousButton = _sel.parentNode.querySelector(
						'.revolver-carousel__nav-buttons-button--prev'
					);

					if (previousButton) {
						previousButton.addEventListener('click', function () {
							carousel.previous();
						});
					}

					// next
					const nextButton = _sel.parentNode.querySelector(
						'.revolver-carousel__nav-buttons-button--next'
					);

					if (nextButton) {
						nextButton.addEventListener('click', function () {
							carousel.next();
						});
					}
				}
			});
	}

	function pastEvents() {
		let page = 1;
		const list = document.querySelector('.site-events__past-events-list');

		document
			.querySelector('.site-events__load-more')
			.addEventListener('click', (e) => {
				const button = e.target;

				e.preventDefault();

				button.classList.add('site-events__load-more--loading');

				const data = new URLSearchParams({
					action: 'pastEventsGetter',
					page: (page += 1),
					nonce: farloAjaxHandler.nonce,
				});

				fetch(farloAjaxHandler.ajaxurl, {
					method: 'POST',
					body: data,
					headers: {
						Accept: 'application/json',
						'Content-type': 'application/x-www-form-urlencoded',
						'X-WP-Nonce': farloAjaxHandler.nonce,
					},
				})
					.then((response) => response.text())
					.then((res) => {
						if (res !== '') {
							list.insertAdjacentHTML('beforeend', res);
							button.classList.remove(
								'site-events__load-more--loading'
							);

							if (page === parseInt(list.dataset.maxPages)) {
								button.remove();
							}
						}
					})
					.catch((error) => {
						console.error('There was an error!', error);
					});
			});
	}

	function productListing() {
		let page = 1;
		const list = document.querySelectorAll('.site-giftshop__load-more');

		list.forEach((_sel) => {
			_sel.addEventListener('click', (e) => {
				const button = e.target;
				const productList = button.parentNode.parentNode.querySelector(
					'.site-giftshop__product-list'
				);

				e.preventDefault();

				button.classList.add('site-giftshop__load-more--loading');

				const data = new URLSearchParams({
					action: 'productListingGetter',
					page: (page += 1),
					term_id: productList.dataset.termId,
					nonce: farloAjaxHandler.nonce,
				});

				fetch(farloAjaxHandler.ajaxurl, {
					method: 'POST',
					body: data,
					headers: {
						Accept: 'application/json',
						'Content-type': 'application/x-www-form-urlencoded',
						'X-WP-Nonce': farloAjaxHandler.nonce,
					},
				})
					.then((response) => response.text())
					.then((res) => {
						if (res !== '') {
							productList.insertAdjacentHTML('beforeend', res);
							button.classList.remove(
								'site-giftshop__load-more--loading'
							);

							if (
								page === parseInt(productList.dataset.maxPages)
							) {
								button.remove();
							}
						}
					})
					.catch((error) => {
						console.error('There was an error!', error);
					});
			});
		});
	}

	function klaroCookieUpdated() {
		if (typeof klaro !== 'undefined') {
			const dataLayer = window.dataLayer || [];

			window.klaro.exports.getManager().watch({
				update(obj, name, data) {
					if (name === 'saveConsents') {
						dataLayer.push({ event: 'klaro-updated' });
					}
				},
			});
		}
	}

	function farloModal(_sel) {
		let iframeSrc = '';

		_sel.addEventListener('click', (e) => {
			e.preventDefault();

			e.currentTarget
				.closest('section')
				.querySelector('.site-farlo-ui-modal')
				.classList.toggle('site-farlo-ui-modal--is-active');
			document.body.classList.toggle('site-farlo-ui-modal--open');

			const close = e.target
				.closest('section')
				.querySelector('.site-farlo-ui-modal')
				.querySelectorAll(
					'.site-farlo-ui-modal__close, .site-farlo-ui-modal__inner-close'
				);

			if (iframeSrc !== '') {
				e.target
					.closest('section')
					.querySelector('.site-farlo-ui-modal')
					.querySelector('.site-farlo-ui-modal__inner-frame')
					.querySelector('iframe').src = iframeSrc;
			}

			close.forEach((exit) => {
				exit.addEventListener('click', (ev) => {
					ev.preventDefault();
					ev.currentTarget
						.closest('section')
						.querySelector('.site-farlo-ui-modal')
						.classList.remove('site-farlo-ui-modal--is-active');

					if (
						ev.currentTarget
							.closest('section')
							.querySelector('.site-open-table__trigger')
					) {
						ev.currentTarget
							.closest('section')
							.querySelector('.site-open-table__trigger')
							.removeAttribute('disabled');
					}
					document.body.classList.remove('site-farlo-ui-modal--open');
					if (document.querySelector('.site-open-table__script')) {
						document
							.querySelector('.site-open-table__script')
							.remove();
					}
					if (
						document.querySelector('[id^="ot-widget"]') &&
						document.querySelector('[id^="ot-widget"]').id
					) {
						document.querySelector('[id^="ot-widget"]').remove();
					}

					if (
						e.target
							.closest('section')
							.querySelector('.site-farlo-ui-modal')
							.querySelector('.site-farlo-ui-modal__inner-frame')
							.querySelector('iframe')
					) {
						const iframe = e.target
							.closest('section')
							.querySelector('.site-farlo-ui-modal')
							.querySelector('.site-farlo-ui-modal__inner-frame')
							.querySelector('iframe');

						if (iframe) {
							iframeSrc = iframe.src;

							setTimeout(() => {
								iframe.src = '';
							}, 50);
						}
					}
				});
			});
		});
	}

	function faqs() {
		const accordions = document.querySelectorAll(
			'.site-faqs__accordion-faq'
		);

		const openAccordion = (accordion) => {
			const answer = accordion.querySelector(
				'.site-faqs__accordion-answer'
			);
			accordion.classList.add('site-faqs__accordion-faq--active');
			answer.style.maxHeight = answer.scrollHeight + 'px';
		};

		const closeAccordion = (accordion) => {
			const answer = accordion.querySelector(
				'.site-faqs__accordion-answer'
			);
			accordion.classList.remove('site-faqs__accordion-faq--active');
			answer.style.maxHeight = null;
		};

		accordions.forEach((accordion) => {
			const question = accordion.querySelector(
				'.site-faqs__accordion-question'
			);
			const answer = accordion.querySelector(
				'.site-faqs__accordion-answer'
			);

			question.onclick = () => {
				if (answer.style.maxHeight) {
					closeAccordion(accordion);
				} else {
					accordions.forEach((acc) => closeAccordion(acc));
					openAccordion(accordion);
				}
			};
		});
	}

	function isInViewport(el) {
		const rect = el.getBoundingClientRect();

		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <=
				(window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <=
				(window.innerWidth || document.documentElement.clientWidth)
		);
	}

	function bookTicketState(_sel) {
		const bookButton = document.querySelector(
			'.site-event-hero-banner__button'
		);
		const navBookButton = document.querySelector(
			'.site-event__on-page-navigation-button'
		);

		if (isInViewport(_sel)) {
			if (bookButton) {
				bookButton.classList.add(
					'site-event-hero-banner__button--hidden'
				);
			}
			if (navBookButton) {
				navBookButton.classList.add(
					'site-event__on-page-navigation-button--hidden'
				);
			}
		} else {
			if (bookButton) {
				bookButton.classList.remove(
					'site-event-hero-banner__button--hidden'
				);
			}

			if (navBookButton) {
				navBookButton.classList.remove(
					'site-event__on-page-navigation-button--hidden'
				);
			}
		}
	}

	function bookTickets(_sel) {
		_sel.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopImmediatePropagation();
			if (document.querySelector('#ticket-calendar')) {
				document
					.querySelector('#ticket-calendar')
					.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}
		});
	}

	function tickXWidget() {
		let k;

		if (!window.txp) {
			window.txp = [];
			window.tx = function () {
				window.txp.push('script');
			};

			const x = document.createElement('script');
			x.id = 'tx';
			x.src =
				'//widgets.tickx.co.uk/js/' + 1 * Date.now() + '/box-office.js';
			k = document.getElementsByTagName('script')[0];
			k.parentNode.insertBefore(x, k);
		}

		function activateTxCalendar() {
			if (
				isInViewport(
					document.querySelector('.site-ticket-calendar__widget')
				) &&
				document.querySelector('.site-ticket-calendar__widget').children
					.length === 0
			) {
				if (
					typeof tx !== 'undefined' &&
					typeof txConfig !== 'undefined'
				) {
					tx({
						widgetId: txConfig.widgetId,
						configId: txConfig.configId,
						selector: '.site-ticket-calendar__widget',
					});
				}
			}

			const bookButton = document.querySelector(
				'.site-event-hero-banner__button'
			);
			const navBookButton = document.querySelector(
				'.site-event__on-page-navigation-button'
			);

			if (bookButton) {
				bookButton.classList.toggle(
					'site-event-hero-banner__button--hidden',
					isInViewport(
						document.querySelector('.site-ticket-calendar__widget')
					)
				);
			}
			if (navBookButton) {
				navBookButton.classList.toggle(
					'site-event__on-page-navigation-button--hidden',
					isInViewport(
						document.querySelector('.site-ticket-calendar__widget')
					)
				);
			}
		}

		function activateTxCalendarFromUrl() {
			if (
				typeof tx !== 'undefined' &&
				typeof txConfig !== 'undefined' &&
				window.location.hash.split('?')[1].split('=') &&
				typeof window.location.hash.split('?')[1].split('=')[1] !==
					'undefined'
			) {
				if (
					isInViewport(
						document.querySelector('.site-ticket-calendar__widget')
					) &&
					document.querySelector('.site-ticket-calendar__widget')
						.children.length === 0
				) {
					tx({
						widgetId: txConfig.widgetId,
						configId: window.location.hash
							.split('?')[1]
							.split('=')[1],
						selector: '.site-ticket-calendar__widget',
					});
				}
			}
		}

		window.addEventListener('load', () => {
			if (window.location.hash && window.location.hash.includes('flow')) {
				if (
					document.querySelector(
						'.site-event__on-page-navigation-button'
					)
				) {
					document
						.querySelector('.site-event__on-page-navigation-button')
						.click();
				}
				activateTxCalendarFromUrl();
			} else {
				activateTxCalendar();
			}
		});
		window.addEventListener('resize', () => {
			if (window.location.hash && window.location.hash.includes('flow')) {
				activateTxCalendarFromUrl();
			} else {
				activateTxCalendar();
			}
		});
		window.addEventListener('scroll', () => {
			if (window.location.hash && window.location.hash.includes('flow')) {
				activateTxCalendarFromUrl();
			} else {
				activateTxCalendar();
			}
		});
	}

	function tickXOnboarding() {
		let k;

		if (!window.txp) {
			window.txp = [];
			window.tx = function () {
				window.txp.push('script');
			};
			const x = document.createElement('script');
			x.id = 'tx';
			x.src =
				'//widgets.tickx.co.uk/js/' + 1 * Date.now() + '/box-office.js';
			k = document.getElementsByTagName('script')[0];
			k.parentNode.insertBefore(x, k);
		}

		document
			.querySelectorAll('.site-mailing-list-button')
			.forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					if (typeof tx !== 'undefined') {
						tx({
							widgetId: 'mckittrickhotel',
							configId: 'j_ci3CmrZ',
							type: 'onboarding',
						});
					}
				});
			});
	}

	function masonryGridListing(_sel) {
		function resizeGridItem(item) {
			const grid = _sel.querySelector(
				'.site-event-information__items-list'
			);
			const rowHeight = parseInt(
				window.getComputedStyle(grid).getPropertyValue('grid-auto-rows')
			);
			const rowGap = parseInt(
				window.getComputedStyle(grid).getPropertyValue('grid-row-gap')
			);
			const rowSpan = Math.ceil(
				(item.querySelector(
					'.site-event-information__items-list-description'
				).clientHeight +
					rowGap +
					rowGap) /
					(rowHeight + rowGap)
			);
			item.style.gridRowEnd = 'span ' + rowSpan;
			console.log(rowSpan);
		}

		function resizeAllGridItems() {
			const allItems = document.getElementsByClassName(
				'site-event-information__items-list-item'
			);
			for (let i = 0; i < allItems.length; i += 1) {
				resizeGridItem(allItems[i]);
			}
		}

		window.addEventListener('load', () => {
			if (window.innerWidth >= 1024) {
				resizeAllGridItems();
			}
		});
		window.addEventListener('resize', () => {
			if (window.innerWidth >= 1024) {
				resizeAllGridItems();
			}
		});
	}

	function masonryGridListingPosts(_sel) {
		function resizeGridItem(item) {
			const grid = _sel.querySelector('.love-letters__posts');
			const rowHeight = parseInt(
				window.getComputedStyle(grid).getPropertyValue('grid-auto-rows')
			);
			const rowGap = parseInt(
				window.getComputedStyle(grid).getPropertyValue('grid-row-gap')
			);

			let imageHeight = 0;
			const image = item.querySelector('img');
			if (image) {
				imageHeight = image.clientHeight;
			}

			const h3Height = item.querySelector('h3').clientHeight;
			const anchorHeight = item.querySelector('a').clientHeight;
			const spanHeight = item.querySelector('span').clientHeight;
			const buttonHeight = item.querySelector(
				'.love-letters__posts-item-button'
			).clientHeight;
			const paragraphHeight = item.querySelector('p').clientHeight;

			let rowSpan = Math.ceil(
				(h3Height +
					anchorHeight +
					imageHeight +
					spanHeight +
					buttonHeight +
					paragraphHeight +
					100 +
					rowGap * 2) /
					(rowHeight + rowGap)
			);

			item.style.gridRowEnd = 'span ' + rowSpan;
		}

		function resizeAllGridItems() {
			const allItems = _sel.querySelectorAll('.love-letters__posts-item');
			allItems.forEach(resizeGridItem);
		}

		window.addEventListener('load', () => {
			if (window.innerWidth >= 1024) {
				resizeAllGridItems();
			}
		});

		if (document.querySelector('.love-letters__load-more')) {
			document
				.querySelector('.love-letters__load-more')
				.addEventListener('click', (e) => {
					setTimeout(resizeAllGridItems, 700);
					setTimeout(resizeAllGridItems, 1000);
				});
		}

		window.addEventListener('resize', () => {
			if (window.innerWidth >= 1024) {
				resizeAllGridItems();
			}
		});
	}

	function pastPosts() {
		let page = 1;
		const list = document.querySelector('.love-letters__posts');

		if (document.querySelector('.love-letters__load-more')) {
			document
				.querySelector('.love-letters__load-more')
				.addEventListener('click', (e) => {
					const button = e.target;

					e.preventDefault();

					button.classList.add('love-letters__load-more--loading');

					const data = new URLSearchParams({
						action: 'pastPostsGetter',
						page: (page += 1),
						nonce: farloAjaxHandler.nonce,
					});

					fetch(farloAjaxHandler.ajaxurl, {
						method: 'POST',
						body: data,
						headers: {
							Accept: 'application/json',
							'Content-type': 'application/x-www-form-urlencoded',
							'X-WP-Nonce': farloAjaxHandler.nonce,
						},
					})
						.then((response) => response.text())
						.then((res) => {
							if (res !== '') {
								list.insertAdjacentHTML('beforeend', res);

								button.classList.remove(
									'love-letters__load-more--loading'
								);

								if (page === parseInt(list.dataset.maxPages)) {
									button.remove();
								}
							}
						})
						.catch((error) => {
							console.error('There was an error!', error);
						});
				});
		}
	}

	function eventPageNavigation() {
		const eventNavigation = document.querySelector(
			'.site-event__on-page-navigation'
		);
		let heroBannerHeight = 0;

		if (window.innerWidth > 980) {
			document
				.querySelector('.site-event-hero-banner')
				.appendChild(eventNavigation);
		} else if (window.innerWidth <= 980) {
			document
				.querySelector('.site-header__selection')
				.querySelector('.site-header__selection-nav')
				.appendChild(eventNavigation);
		}

		if (document.querySelector('.site-header__selection-select')) {
			document
				.querySelector('.site-header__selection-select')
				.addEventListener('click', (e) => {
					e.currentTarget.parentNode
						.querySelector('.site-header__selection-nav')
						.classList.toggle('site-header__selection-nav--active');
				});
		}

		eventNavigation.querySelectorAll('button').forEach((_sel) => {
			_sel.addEventListener('click', (e) => {
				e.preventDefault();

				for (
					let i = 0;
					i <
					document.querySelectorAll('[data-nav-item-name]').length;
					i += 1
				) {
					if (
						e.target.dataset.navItem ===
						document.querySelectorAll('[data-nav-item-name]')[i]
							.dataset.navItemName
					) {
						document
							.querySelectorAll('[data-nav-item-name]')
							[i].scrollIntoView({
								behavior: 'smooth',
								block: 'start',
							});
					}
				}

				if (
					e.target.closest('.site-header__selection-nav') &&
					e.target
						.closest('.site-header__selection-nav')
						.classList.contains(
							'site-header__selection-nav--active'
						)
				) {
					document
						.querySelector('.site-header__selection-nav')
						.classList.remove('site-header__selection-nav--active');
				}
			});
		});

		function currentSelection() {
			let currentSection = '';

			heroBannerHeight = document.querySelector(
				'.site-event-hero-banner'
			).clientHeight;

			if (document.querySelector('.site-event-hero-banner__button')) {
				document
					.querySelector('.site-event-hero-banner__button')
					.classList.toggle(
						'site-event-hero-banner__button--fixed',
						window.scrollY > heroBannerHeight
					);
				document
					.querySelector('.site-event-hero-banner__info')
					.classList.toggle(
						'site-event-hero-banner__info--fixed',
						window.scrollY > heroBannerHeight
					);

				document.body.classList.toggle(
					'site-event-hero-banner__info--is-fixed',
					window.scrollY > heroBannerHeight
				);
			}

			for (
				let i = 0;
				i < document.querySelectorAll('[data-nav-item-name]').length;
				i += 1
			) {
				if (
					window.scrollY >=
					document.querySelectorAll('[data-nav-item-name]')[i]
						.offsetTop -
						document.querySelector(
							'.site-event__on-page-navigation'
						).clientHeight
				) {
					currentSection = document.querySelectorAll(
						'[data-nav-item-name]'
					)[i].dataset.navItemName;
				}
			}

			if (currentSection !== '') {
				for (
					let i = 0;
					i <
					window._farlo.helpers.getSiblings(
						eventNavigation.querySelector(
							'[data-nav-item="' + currentSection + '"]'
						)
					).length;
					i += 1
				) {
					window._farlo.helpers
						.getSiblings(
							eventNavigation.querySelector(
								'[data-nav-item="' + currentSection + '"]'
							)
						)
						[i].classList.remove(
							'site-event__on-page-navigation-item--active'
						);
					eventNavigation
						.querySelector(
							'[data-nav-item="' + currentSection + '"]'
						)
						.classList.add(
							'site-event__on-page-navigation-item--active'
						);
				}
			}
		}

		function unstickNavigation() {
			// Get the element and footer
			const footer = document.querySelector('.site-footer');

			// Get the element and footer positions
			const elementRect = eventNavigation.getBoundingClientRect();
			const footerRect = footer.getBoundingClientRect();

			// Calculate the bottom position of the element
			const elementBottom = elementRect.top + elementRect.height;

			// Check if the element's bottom position is above the footer's top position
			if (elementBottom < footerRect.top) {
				// Calculate the offset needed to stick the element at the top of the footer
				eventNavigation.classList.add(
					'site-event__on-page-navigation--stick'
				);
				eventNavigation.removeAttribute('style');
			} else {
				// Reset the transform when the element is above the footer
				const offset = footerRect.top - elementBottom;
				eventNavigation.classList.remove(
					'site-event__on-page-navigation--stick'
				);
				eventNavigation.style.borderBottom =
					getComputedStyle(eventNavigation).borderTop;
				eventNavigation.style.bottom = `${offset}px`;
			}
		}

		window.addEventListener('scroll', () => {
			currentSelection();
			unstickNavigation();
		});

		window.addEventListener('resize', () => {
			if (window.innerWidth > 980) {
				document
					.querySelector('.site-event-hero-banner')
					.appendChild(eventNavigation);
				currentSelection();
			} else if (window.innerWidth <= 980) {
				document
					.querySelector('.site-header__selection')
					.querySelector('.site-header__selection-nav')
					.appendChild(eventNavigation);
			}

			heroBannerHeight = document.querySelector(
				'.site-event-hero-banner'
			).clientHeight;
		});

		window.addEventListener('load', () => {
			currentSelection();
			unstickNavigation();
		});
	}

	function venuePageNavigation() {
		const venueNavigation = document.querySelector(
			'.site-venue__on-page-navigation'
		);

		function currentSelection() {
			let currentSection = '';

			for (
				let i = 0;
				i < document.querySelectorAll('[data-nav-item-name]').length;
				i += 1
			) {
				if (
					document.documentElement.scrollTop >=
					document
						.querySelectorAll('[data-nav-item-name]')
						[i].getBoundingClientRect().bottom -
						document.querySelector(
							'.site-venue__on-page-navigation'
						).clientHeight
				) {
					currentSection = document.querySelectorAll(
						'[data-nav-item-name]'
					)[i].dataset.navItemName;
				}
			}

			if (currentSection !== '') {
				for (
					let i = 0;
					i <
					window._farlo.helpers.getSiblings(
						venueNavigation.querySelector(
							'[data-nav-item="' + currentSection + '"]'
						)
					).length;
					i += 1
				) {
					window._farlo.helpers
						.getSiblings(
							venueNavigation.querySelector(
								'[data-nav-item="' + currentSection + '"]'
							)
						)
						[i].classList.remove(
							'site-venue__on-page-navigation-item--active'
						);
					venueNavigation
						.querySelector(
							'[data-nav-item="' + currentSection + '"]'
						)
						.classList.add(
							'site-venue__on-page-navigation-item--active'
						);
				}
			}
		}

		function unstickNavigation() {
			// Get the element and footer
			const footer = document.querySelector('.site-footer');

			// Get the element and footer positions
			const elementRect = venueNavigation.getBoundingClientRect();
			const footerRect = footer.getBoundingClientRect();

			// Calculate the bottom position of the element
			const elementBottom = elementRect.top + elementRect.height;

			// Check if the element's bottom position is above the footer's top position
			if (elementBottom < footerRect.top) {
				// Calculate the offset needed to stick the element at the top of the footer
				venueNavigation.classList.add(
					'site-event__on-page-navigation--stick'
				);
				venueNavigation.removeAttribute('style');
			} else {
				// Reset the transform when the element is above the footer
				const offset = footerRect.top - elementBottom;
				venueNavigation.classList.remove(
					'site-event__on-page-navigation--stick'
				);
				venueNavigation.style.borderBottom =
					getComputedStyle(venueNavigation).borderTop;
				venueNavigation.style.bottom = `${offset}px`;
			}
		}

		if (window.innerWidth > 980) {
			document
				.querySelector('.site-venue-hero-banner__text')
				.appendChild(venueNavigation);
		} else if (window.innerWidth < 980) {
			document
				.querySelector('.site-header__selection-nav')
				.appendChild(venueNavigation);

			if (document.querySelector('.site-venue-hero-banner__button')) {
				document.body.classList.add(
					'single-restaurantslounges--reservation-button'
				);
			}
		}

		document
			.querySelector('.site-header__selection-select')
			.addEventListener('click', (e) => {
				e.currentTarget.parentNode
					.querySelector('.site-header__selection-nav')
					.classList.toggle('site-header__selection-nav--active');
			});

		venueNavigation.querySelectorAll('button').forEach((_sel) => {
			_sel.addEventListener('click', (e) => {
				e.preventDefault();

				for (
					let i = 0;
					i <
					document.querySelectorAll('[data-nav-item-name]').length;
					i += 1
				) {
					if (
						e.target.dataset.navItem ===
						document.querySelectorAll('[data-nav-item-name]')[i]
							.dataset.navItemName
					) {
						document
							.querySelectorAll('[data-nav-item-name]')
							[i].scrollIntoView({
								behavior: 'smooth',
								block: 'start',
							});
					}
				}

				if (
					e.target.parentNode.querySelector(
						'.site-header__selection-nav'
					) &&
					e.target.parentNode
						.querySelector('.site-header__selection-nav')
						.classList.contains(
							'site-header__selection-nav--active'
						)
				) {
					document
						.querySelector('.site-header__selection-nav')
						.classList.remove('site-header__selection-nav--active');
				}
			});
		});

		window.addEventListener('resize', () => {
			if (window.innerWidth > 980) {
				document
					.querySelector('.site-venue-hero-banner__text')
					.appendChild(venueNavigation);

				currentSelection();
			} else if (window.innerWidth < 980) {
				document
					.querySelector('.site-header__selection-nav')
					.appendChild(venueNavigation);

				if (document.querySelector('.site-venue-hero-banner__button')) {
					document.body.classList.add(
						'single-restaurantslounges--reservation-button'
					);
				}
			}
		});

		window.addEventListener('scroll', () => {
			currentSelection();
			unstickNavigation();
		});

		window.addEventListener('load', () => {
			currentSelection();
			unstickNavigation();
		});
	}

	function backToTop() {
		document
			.querySelector('.site-back-to-top')
			.addEventListener('click', (e) => {
				e.preventDefault();

				document.body.scrollIntoView({ behavior: 'smooth' });
			});

		window.addEventListener('scroll', () => {
			document
				.querySelector('.site-back-to-top')
				.classList.toggle(
					'site-back-to-top--show',
					window.scrollY > 200
				);
		});
	}

	function relatedEvents() {
		const relatedEventsDiv = document.querySelector(
			'.site-event-hero-banner__related-events'
		);
		const heroBanner = relatedEventsDiv.parentNode;

		if (window.innerWidth > 980) {
			heroBanner.appendChild(relatedEventsDiv);
			document.querySelector(
				'.site-event-hero-banner__related-events'
			).style.paddingTop =
				document.querySelector('.site-event-hero-banner__info')
					.clientHeight + 'px';
		} else if (window.innerWidth <= 980) {
			relatedEventsDiv
				.closest('.site-page')
				.appendChild(relatedEventsDiv);
		}

		window.addEventListener('resize', () => {
			if (window.innerWidth > 980) {
				heroBanner.appendChild(relatedEventsDiv);
				document.querySelector(
					'.site-event-hero-banner__related-events'
				).style.paddingTop =
					document.querySelector('.site-event-hero-banner__info')
						.clientHeight + 'px';
			} else if (window.innerWidth <= 980) {
				relatedEventsDiv
					.closest('.site-page')
					.appendChild(relatedEventsDiv);

				carousels();
			}
		});
	}

	// Redirect to Private Events
	function privateEventSelection() {
		if (document.querySelector('#gform_1')) {
			document
				.querySelector('form')
				.querySelector('select')
				.addEventListener('change', (e) => {
					if (
						e.target.value === 'Private Events' ||
						e.target.value === 'Group Bookings'
					) {
						window.location.href = '/private-events/';
					}
				});
		}
	}

	function importantInformationBanner() {
		const infoBanner = document.querySelector(
			'.site-important-information-banner'
		);
		const closeButtons = [];

		closeButtons.push(
			infoBanner.querySelector('.site-farlo-ui-modal__inner-close')
		);
		closeButtons.push(
			infoBanner.querySelector('.site-farlo-ui-modal__close')
		);

		closeButtons.forEach((_sel) => {
			_sel.addEventListener('click', () => {
				window._farlo.storage.cookie.handle(
					'informationBannerSeen',
					true,
					432e3,
					'/',
					window.location.host
				);
			});
		});
	}

	function footerSizes() {
		document.documentElement.style.setProperty(
			'--site-footer-height',
			`${document.querySelector('.site-footer').clientHeight}px`
		);

		footerHeight = document.querySelector('.site-footer').clientHeight;
		return footerHeight;
	}

	function openTable(_sel) {
		const opentableUrl =
			'//www.opentable.com/widget/reservation/loader?rid=101443&type=wide&theme=standard&overlay=true&color=2&dark=true&iframe=true&domain=com&lang=en-US&newtab=false&ot_source=Restaurant Website';

		_sel.addEventListener('click', (e) => {
			const s = document.createElement('script');
			s.setAttribute('src', opentableUrl);
			s.setAttribute('class', 'site-open-table__script');
			e.currentTarget.setAttribute('disabled', 'disabled');
			e.currentTarget.parentNode.appendChild(s);
		});
	}

	function farloUiMcSignup(_sel) {
		let farloUiSignupForm = null;

		if (farloUiSignupForm) {
			farloUiSignupForm.toggleForm();
		} else {
			farloUiSignupForm = new FarloUiMc(_sel.id);
		}
	}

	function woocommerceStoreNotice() {
		document.body.classList.add('woocommerce__has-notice');

		document
			.querySelector('.woocommerce-store-notice__dismiss-link')
			.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				document.body.classList.remove('woocommerce__has-notice');
			});
	}

	// Function to update the label text
	function updateLabelForCountry(countryCode, labelElement, newText) {
		const countrySelect = document.querySelector(countryCode);
		if (countrySelect && countrySelect.value === 'US') {
			labelElement.textContent = newText;
		}
	}

	function featuredEventCountdownToEndDate(
		countdown,
		endHeading,
		endText,
		endImage
	) {
		const countdownContainer = document.querySelector(
			'.site-events__upcoming-events-item-info-text--countdown'
		);
		const figureElement = document.querySelector(
			'.site-events__upcoming-events-item-image'
		);
		const imageElement = figureElement?.querySelector(
			'.site-events__upcoming-events-item-image-src'
		);

		if (!countdownContainer) return;

		function updateCountdown() {
			// Decrement the seconds
			countdown.seconds--;

			if (countdown.seconds < 0) {
				countdown.seconds = 59;
				countdown.minutes--;

				if (countdown.minutes < 0) {
					countdown.minutes = 59;
					countdown.hours--;

					if (countdown.hours < 0) {
						countdown.hours = 23;
						countdown.days--;

						if (countdown.days < 0) {
							clearInterval(interval);
							handleCountdownEnd(endHeading, endText, endImage);
							return;
						}
					}
				}
			}

			// Update the countdown timer display
			countdownContainer.querySelector(
				'.site-events__upcoming-events-countdown-timer'
			).innerHTML =
				`${countdown.days}<span class="site-events__upcoming-events-countdown-timer-marker">d</span> ` +
				`${countdown.hours}<span class="site-events__upcoming-events-countdown-timer-marker">h</span> ` +
				`${countdown.minutes}<span class="site-events__upcoming-events-countdown-timer-marker">m</span> ` +
				`${countdown.seconds}<span class="site-events__upcoming-events-countdown-timer-marker">s</span>`;
		}

		function handleCountdownEnd(heading, text, endImage) {
			// Replace the countdown with end text
			countdownContainer.innerHTML = `
				<h3 class="site-events__upcoming-events-end-heading">${heading}</h3>
				<p class="site-events__upcoming-events-end-text">${text}</p>
			`;

			// Replace the image dynamically
			if (figureElement && endImage) {
				if (imageElement) {
					imageElement.src = endImage; // Update the image source
				} else {
					// Fallback: Add a new img tag if the image element is missing
					const newImage = document.createElement('img');
					newImage.src = endImage;
					newImage.alt = 'Event End Image';
					newImage.className =
						'site-events__upcoming-events-item-image-src';
					figureElement.appendChild(newImage);
				}
			}
		}

		// Start the countdown update loop
		const interval = setInterval(updateCountdown, 1000);
	}

	history.pushState = function (state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.querySelector('.site-entrance')) {
			entranceAnimation();
		}

		if (document.querySelector('.site-faqs')) {
			faqs();
		}
		if (document.querySelector('.site-horizontal-accordion')) {
			horizontalAccordion();
		}

		if (document.querySelector('.site-events__load-more')) {
			pastEvents();
		}

		if (document.querySelector('.love-letters__load-more')) {
			pastPosts();
		}

		if (document.querySelector('.site-giftshop__load-more')) {
			productListing();
		}

		if (document.querySelector('.site-event__on-page-navigation')) {
			eventPageNavigation();
		}

		if (document.querySelector('.site-venue__on-page-navigation')) {
			venuePageNavigation();
		}

		if (document.querySelector('.site-ticket-calendar__widget')) {
			tickXWidget();
		}

		if (document.querySelector('.site-mailing-list-button')) {
			tickXOnboarding();
		}

		if (document.querySelector('.site-back-to-top')) {
			backToTop();
		}

		if (document.querySelector('form')) {
			privateEventSelection();
		}

		if (document.querySelector('.site-event-hero-banner__related-events')) {
			relatedEvents();
		}

		if (document.querySelector('.site-important-information-banner')) {
			importantInformationBanner();
		}

		if (
			document.querySelector(
				'.site-events__upcoming-events-countdown-timer'
			)
		) {
			const countdownElement = document.querySelector(
				'.site-events__upcoming-events-item-info-text--countdown'
			);
			const figureElement = document.querySelector(
				'.site-events__upcoming-events-item-image'
			);
			const imageElement = figureElement?.querySelector(
				'.site-events__upcoming-events-item-image-src'
			);
			const linkElement = document.querySelector(
				'.site-events__upcoming-events-item-link'
			); // The link element to update

			if (countdownElement) {
				const countdown = {
					days: parseInt(
						countdownElement.getAttribute('data-countdown-days'),
						10
					),
					hours: parseInt(
						countdownElement.getAttribute('data-countdown-hours'),
						10
					),
					minutes: parseInt(
						countdownElement.getAttribute('data-countdown-minutes'),
						10
					),
					seconds: parseInt(
						countdownElement.getAttribute('data-countdown-seconds'),
						10
					),
				};

				// Function to check if the countdown has ended
				const hasCountdownEnded = () =>
					countdown.days <= 0 &&
					countdown.hours <= 0 &&
					countdown.minutes <= 0 &&
					countdown.seconds <= 0;

				// Handle the countdown end state
				const handleCountdownEnd = () => {
					const endImage =
						countdownElement.getAttribute('data-end-image');
					if (endImage) {
						if (imageElement) {
							// Update the existing image
							imageElement.src = `${endImage}?t=${new Date().getTime()}`;
						} else if (figureElement) {
							// Create and append a new image element
							const newImage = document.createElement('img');
							newImage.src = `${endImage}?t=${new Date().getTime()}`;
							newImage.alt = 'Event End Image';
							newImage.className =
								'site-events__upcoming-events-item-image-src';
							figureElement.appendChild(newImage);
						}
					}

					// Replace countdown text with end text
					const endHeading =
						countdownElement.getAttribute('data-end-heading');
					const endText =
						countdownElement.getAttribute('data-end-text');
					countdownElement.innerHTML = `
						<h3 class="site-events__upcoming-events-countdown-heading site-events__upcoming-events-end-heading">${endHeading}</h3>
						<p class="site-events__upcoming-events-countdown-text site-events__upcoming-events-end-text">${endText}</p>
					`;

					// Update the link
					const endLink =
						countdownElement.getAttribute('data-end-link');
					if (endLink && linkElement) {
						linkElement.href = endLink;
					}
				};

				// Check if the countdown has already ended on page load
				if (hasCountdownEnded()) {
					handleCountdownEnd();
				} else {
					// If the countdown is still ongoing, start the interval
					const interval = setInterval(() => {
						// Decrement the seconds
						countdown.seconds--;

						if (countdown.seconds < 0) {
							countdown.seconds = 59;
							countdown.minutes--;

							if (countdown.minutes < 0) {
								countdown.minutes = 59;
								countdown.hours--;

								if (countdown.hours < 0) {
									countdown.hours = 23;
									countdown.days--;

									if (countdown.days < 0) {
										clearInterval(interval);
										handleCountdownEnd();
										return;
									}
								}
							}
						}

						// Update the countdown timer display
						const timerElement = countdownElement.querySelector(
							'.site-events__upcoming-events-countdown-timer'
						);
						if (timerElement) {
							timerElement.innerHTML = `
								${countdown.days}<span class="site-events__upcoming-events-countdown-timer-marker">d</span>
								${countdown.hours}<span class="site-events__upcoming-events-countdown-timer-marker">h</span>
								${countdown.minutes}<span class="site-events__upcoming-events-countdown-timer-marker">m</span>
								${countdown.seconds}<span class="site-events__upcoming-events-countdown-timer-marker">s</span>
							`;
						}
					}, 1000);
				}
			}
		}

		setTimeout(() => {
			if (
				document.querySelector('.woocommerce-store-notice') &&
				document
					.querySelector('.woocommerce-store-notice')
					.getAttribute('style') !== 'display:none;'
			) {
				woocommerceStoreNotice();
			}
		}, 800);

		if (document.querySelector('.site-footer')) {
			footerSizes();
		}

		if (document.querySelector('.site-farlo-ui-crm')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiMcSignup(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-crm__toggle')) {
			document
				.querySelectorAll('.site-farlo-ui-crm__toggle')
				.forEach((_sel) => {
					_sel.addEventListener('click', (e) => {
						e.preventDefault();
						e.stopImmediatePropagation();
						farloUiMcSignup(e);
					});
				});
		}

		document
			.querySelectorAll(
				'.site-event-hero-banner__button, .site-event__on-page-navigation-button'
			)
			.forEach((_sel) => {
				bookTickets(_sel);
			});

		document
			.querySelectorAll('.site-navigation__sub-menu')
			.forEach((_sel) => {
				navigation(_sel);
			});

		document
			.querySelectorAll('.site-farlo-ui-modal-trigger')
			.forEach((_sel) => {
				farloModal(_sel);
			});

		document
			.querySelectorAll('.site-event-information__items')
			.forEach((_sel) => {
				masonryGridListing(_sel);
			});

		document
			.querySelectorAll('.love-letters__posts-item')
			.forEach((_sel) => {
				masonryGridListingPosts(document);
			});

		document
			.querySelectorAll('.site-open-table__trigger')
			.forEach((_sel) => {
				openTable(_sel);
			});
	});

	document.addEventListener('click', (e) => {
		if (document.querySelector('[id^="ot-widget"]') !== null) {
			const openTableWidgets =
				document.querySelectorAll('[id^="ot-widget"]');

			for (let i = 0; i < openTableWidgets.length; i += 1) {
				if (!openTableWidgets[i].isSameNode(e.target)) {
					openTableWidgets[i].parentNode
						.querySelector('.site-open-table__trigger')
						.removeAttribute('disabled');
					openTableWidgets[i].remove();
				}
			}
		}
	});

	window.addEventListener('scroll', () => {
		if (document.querySelector('.site-header')) {
			document
				.querySelector('.site-header')
				.classList.toggle('site-header--fixed', window.scrollY > 0);
		}
		footerSizes();
	});

	window.addEventListener('resize', footerSizes);

	window.addEventListener('load', () => {
		carousels();

		if (document.querySelector('.site-header')) {
			document
				.querySelector('.site-header')
				.classList.toggle('site-header--fixed', window.scrollY > 0);
		}

		if (document.querySelector('.klaro')) {
			klaroCookieUpdated();
		}

		if (
			document.querySelector('label[for="billing_city"]') ||
			document.querySelector('label[for="shipping_city"]')
		) {
			// Update billing city label
			updateLabelForCountry(
				'select#billing_country',
				document.querySelector('label[for="billing_city"]'),
				'City (US)'
			);
			// Update shipping city label
			updateLabelForCountry(
				'select#shipping_country',
				document.querySelector('label[for="shipping_city"]'),
				'City (US)'
			);
		}
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker
			.getRegistrations()
			.then(function (registrations) {
				for (const registration of registrations) {
					registration.unregister();
				}
			});
	}
})(document, window, history);
